import { Route, Redirect } from 'react-router-dom';
import { getSessionStatus } from '../session/auth.js';
import routes from '../routes/routes.json';
import { getEventName, isEmailReportCTA, sendPlausibleEvent } from '../shared/analytics.js';
import '../../configs/config.js'

const route = routes.contentroutes;

export default function ProtectedRoute({ component: Component, ...rest }) {
  let sessStatus = getSessionStatus();

  if (window.APP_CONFIG.analytics.plausibleAnalytics && isEmailReportCTA()) {
    const event_name = getEventName();
    sendPlausibleEvent(`${event_name}_clicked`);
  }

  return (
    <Route {...rest} render={(props) => (
      sessStatus ?
        <Component {...props} />
        :
        <Redirect to={{ pathname: route.login, state: { from_url: props.location } }} />
    )} />
  )
}